/**
 * Created by Carsten Bühler
 * User: CBuehler on 01.06.2016
 * Copyright: xdot GmbH 2015
 */

export default {
    openDocumentAssetDialog,
    openDocumentDetailsDialog
};

function openDocumentAssetDialog(relatedAssetEntryId, className, callback) {
    AUI().use('aui-base', 'escape', 'liferay-search-container', 'liferay-portlet-url', function (A) {


        let renderURL = Liferay.PortletURL.createURL(location.pathname),
            eventName = 'RelatedAssetEvent_' + new Date().getTime();

        renderURL.setWindowState('pop_up');
        renderURL.setPortletMode('view');
        renderURL.setParameter('eventName', eventName);

        //ToDo Set as Attribute, but how?
        //renderURL.setAttribute('liferay-ui:input-asset-links:assetEntryId', relatedAssetEntryId);
        //renderURL.setAttribute('liferay-ui:input-asset-links:className', 'com.liferay.portlet.documentlibrary.model.DLFileEntry');

        renderURL.setParameter('refererAssetEntryId', relatedAssetEntryId);
        renderURL.setParameter('struts_action', '/asset_browser/view');
        renderURL.setParameter('fliwasCommand', 'BusinessObjectUpload');
        renderURL.setParameter('showAddButton', 'true');
        renderURL.setParameter('groupId', Liferay.ThemeDisplay.getScopeGroupId());
        renderURL.setParameter('selectedGroupIds', Liferay.ThemeDisplay.getCompanyGroupId() + ',' + Liferay.ThemeDisplay.getScopeGroupId());
        renderURL.setParameter('typeSelection', 'com.liferay.document.library.kernel.model.DLFileEntry');
        renderURL.setPortletId('com_liferay_asset_browser_web_portlet_AssetBrowserPortlet');

        let url = renderURL.toString();

        Liferay.Util.selectEntity(
            {
                dialog: {
                    constrain: true,
                    modal: true
                },
                eventName: eventName,
                id: new Date().getTime(),
                title: 'Dokument verknüpfen',
                uri: url
            },
            function (event) {
                let searchContainerName = '_172_assetEntriesSearchContainerSearchContainer';

                let searchContainer = Liferay.SearchContainer.get(searchContainerName);

                // let entryLink = '<a class="modify-link" data-rowId="' + event.assetentryid + '" href="javascript:;">Entfernen</a>';

                //searchContainer.addRow([ event.assettype, A.Escape.html(event.assettitle), A.Escape.html(event.groupdescriptivename), entryLink ], event.assetentryid);

                searchContainer.updateDataStore();

                callback({
                    relatedAssetEntryId: relatedAssetEntryId,
                    relatedAssetClassName: className,

                    id: parseInt(event.entityid),
                    className: event.assetclassname,
                    title: event.assetentrytitle,
                    type: event.assetentrytype,
                    groupDescriptiveName: event.groupdescriptivename
                });
            }
        );
    }.bind(this));
}



function openDocumentDetailsDialog(fileEntryId, groupId) {
    AUI().use('aui-base', 'escape', 'liferay-search-container', 'liferay-portlet-url', function (A) {
        const  themeDisplay  = window.Liferay.ThemeDisplay;

        //com.liferay.app.builder.web-1.0.45.jar!\META-INF\resources\js\pages\entry\FieldPreview.es.js
        var createFileEntryPreviewURL = function createFileEntryPreviewURL(groupId, fileEntryId) {
            var portletURL = Liferay.PortletURL.createURL(themeDisplay.getLayoutRelativeControlPanelURL());
            portletURL.setParameter('doAsGroupId', groupId);
            portletURL.setParameter('fileEntryId', fileEntryId);
            portletURL.setParameter('mvcRenderCommandName', '/document_library/view_file_entry');
            portletURL.setParameter('p_p_auth', Liferay.authToken);
            portletURL.setParameter('refererGroupId', themeDisplay.getScopeGroupId());
            portletURL.setPortletId(Liferay.PortletKeys.DOCUMENT_LIBRARY);
            portletURL.setPortletMode('view');
            portletURL.setWindowState('pop_up');
            return portletURL.toString();
        };

        const uri = createFileEntryPreviewURL(groupId,fileEntryId);

        Liferay.Util.openWindow(
            {
                dialog: {
                    constrain: true,
                    modal: true
                },
                id: new Date().getTime(),
                title: 'Dokumentenansicht',
                uri
            },
            function (event) {

            }
        );
    }.bind(this));
}




// WEBPACK FOOTER //
// ./js/utils/assetLink.js